import { render, staticRenderFns } from "./DialogSalesInvoicePayment.vue?vue&type=template&id=dfd8c910"
import script from "./DialogSalesInvoicePayment.vue?vue&type=script&setup=true&lang=js"
export * from "./DialogSalesInvoicePayment.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports